<template>
  <div v-if="value" class="subscription-subscription-modal-overlay">
    <div class="subscription-modal">
      <div class="subscription-modal-header">
        <!-- <h2>订阅到期提醒</h2> -->
        <button class="close-btn" @click="closeModal">×</button>
      </div>
      <div class="subscription-modal-body">
        <!-- <p>您的订阅不足7天</p> -->
        <img src="@/assets/images/弹窗.svg" alt="Image Description" />
      </div>
      <div class="subscription-modal-footer">
        <button class="confirm-btn" @click="closeModal">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit('input', false)
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.subscription-subscription-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.subscription-modal {
  width: 100%;
  height: 100%;
  background-color: transparent;
  padding: 20px;
  border-radius: 10px;
  //   box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  .subscription-modal-body {
    width: 560px;
    height: 519px;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.subscription-modal-header {
  margin-bottom: 20px;
  .close-btn {
    position: relative;
    top: 148px;
    left: 245px;
    background-color: transparent;
    border: none;
    font-size: 54px;
    color: transparent;
    cursor: pointer;
  }
}

.subscription-modal-body {
  margin: 0 auto 20px;
}
.subscription-modal-footer {
  .confirm-btn {
    position: relative;
    top: -157px;
    height: 58px;
    width: 186px;
    background-color: transparent;
    color: transparent;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
}
.features {
  display: flex;
  justify-content: space-around;
}

.feature img {
  width: 50px;
  height: 50px;
}

.close-btn {
}
</style>
